import BubbleGif from 'gifs/bubble.gif';
import ChoiceGif from 'gifs/choice.gif';
import FastGif from 'gifs/fast.gif';
import HairbrushGif from 'gifs/hairbrush.gif';
import InsertGif from 'gifs/insert.gif';
import MergeGif from 'gifs/merge.gif';
import MixingGif from 'gifs/mixing.gif';
import PyramidGif from 'gifs/pyramid.gif';

import type { ISortsValues, ITabValues } from './ui/SortingItem.interface';

export const SORTS_VALUES: ISortsValues = {
  bubbleSort: {
    bestTime: 'n',
    gifPath: BubbleGif,
    meanTime: 'n²',
    worstTime: 'n²',
    memory: '1',
    title: 'Сортировка пузырьком',
    description:
      'Сортировка пузырьком — один из самых известных алгоритмов сортировки. Здесь нужно последовательно сравнивать значения соседних элементов и менять числа местами, если предыдущее оказывается больше последующего. Таким образом элементы с большими значениями оказываются в конце списка, а с меньшими остаются в начале.\nЭтот алгоритм считается учебным и почти не применяется на практике из-за низкой эффективности: он медленно работает на тестах, в которых маленькие элементы (их называют «черепахами») стоят в конце массива. Однако на нём основаны многие другие методы, например, шейкерная сортировка и сортировка расчёской.',
  },
  mixingSort: {
    bestTime: 'n',
    gifPath: MixingGif,
    meanTime: 'n²',
    worstTime: 'n²',
    memory: '1',
    title: 'Сортировка перемешиванием (шейкерная)',
    description:
      'Шейкерная сортировка отличается от пузырьковой тем, что она двунаправленная: алгоритм перемещается не строго слева направо, а сначала слева направо, затем справа налево.',
  },
  hairbrushSort: {
    bestTime: 'n log(n)',
    gifPath: HairbrushGif,
    meanTime: '',
    worstTime: 'n²',
    memory: '1',
    title: 'Сортировка расчёской',
    description:
      'Сортировка расчёской — улучшение сортировки пузырьком. Её идея состоит в том, чтобы «устранить» элементы с небольшими значения в конце массива, которые замедляют работу алгоритма. Если при пузырьковой и шейкерной сортировках при переборе массива сравниваются соседние элементы, то при «расчёсывании» сначала берётся достаточно большое расстояние между сравниваемыми значениями, а потом оно сужается вплоть до минимального.\nПервоначальный разрыв нужно выбирать не случайным образом, а с учётом специальной величины — фактора уменьшения, оптимальное значение которого равно 1,247. Сначала расстояние между элементами будет равняться размеру массива, поделённому на 1,247; на каждом последующем шаге расстояние будет снова делиться на фактор уменьшения — и так до окончания работы алгоритма.',
  },
  insertSort: {
    bestTime: 'n',
    gifPath: InsertGif,
    meanTime: 'n²',
    worstTime: 'n²',
    memory: '1',
    title: 'Сортировка вставками',
    description:
      'При сортировке вставками массив постепенно перебирается слева направо. При этом каждый последующий элемент размещается так, чтобы он оказался между ближайшими элементами с минимальным и максимальным значением.',
  },
  choiceSort: {
    bestTime: 'n²',
    gifPath: ChoiceGif,
    meanTime: 'n²',
    worstTime: 'n²',
    memory: '1',
    title: 'Сортировка выбором',
    description:
      'Сначала нужно рассмотреть подмножество массива и найти в нём максимум (или минимум). Затем выбранное значение меняют местами со значением первого неотсортированного элемента. Этот шаг нужно повторять до тех пор, пока в массиве не закончатся неотсортированные подмассивы.',
  },
  fastSort: {
    bestTime: 'n',
    gifPath: FastGif,
    meanTime: 'n log(n)',
    worstTime: 'n²',
    memory: '1',
    title: 'Быстрая сортировка',
    description:
      'Этот алгоритм состоит из трёх шагов. Сначала из массива нужно выбрать один элемент — его обычно называют опорным. Затем другие элементы в массиве перераспределяют так, чтобы элементы меньше опорного оказались до него, а большие или равные — после. А дальше рекурсивно применяют первые два шага к подмассивам справа и слева от опорного значения.\nБыструю сортировку изобрели в 1960 году для машинного перевода: тогда словари хранились на магнитных лентах, а сортировка слов обрабатываемого текста позволяла получить переводы за один прогон ленты, без перемотки назад.',
  },
  mergeSort: {
    bestTime: 'n log(n)',
    gifPath: MergeGif,
    meanTime: 'n log(n)',
    worstTime: 'n log(n)',
    memory: 'n',
    title: 'Сортировка слиянием',
    description:
      'Сортировка слиянием пригодится для таких структур данных, в которых доступ к элементам осуществляется последовательно (например, для потоков). Здесь массив разбивается на две примерно равные части и каждая из них сортируется по отдельности. Затем два отсортированных подмассива сливаются в один.',
  },
  pyramidSort: {
    bestTime: 'n log(n)',
    gifPath: PyramidGif,
    meanTime: 'n log(n)',
    worstTime: 'n log(n)',
    memory: 'n',
    title: 'Пирамидальная сортировка',
    description:
      'При этой сортировке сначала строится пирамида из элементов исходного массива. Пирамида (или двоичная куча) — это способ представления элементов, при котором от каждого узла может отходить не больше двух ответвлений. А значение в родительском узле должно быть больше значений в его двух дочерних узлах.\nПирамидальная сортировка похожа на сортировку выбором, где мы сначала ищем максимальный элемент, а затем помещаем его в конец. Дальше нужно рекурсивно повторять ту же операцию для оставшихся элементов.',
  },
};

export const TABS_VALUES: ITabValues[] = [
  { number: 0, title: 'Описание', key: 'description-tab-key' },
  { number: 1, title: 'Характеристики', key: 'info-tab-key' },
  { number: 2, title: 'Тестирование', key: 'testing-tab-key' },
];
